import axios from 'axios';
import config from "../config.json";

axios.defaults.baseURL = config.SERVER_URL;

axios.interceptors.request.use(function (request) {
    request.headers['Content-Type'] = 'multipart/form-data';
    return request;
});